import { render, staticRenderFns } from "./EtransactDataWallet.vue?vue&type=template&id=35bd7cf8&scoped=true"
import script from "./EtransactDataWallet.vue?vue&type=script&lang=js"
export * from "./EtransactDataWallet.vue?vue&type=script&lang=js"
import style0 from "./EtransactDataWallet.vue?vue&type=style&index=0&id=35bd7cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd7cf8",
  null
  
)

export default component.exports